import useAppDispatch from '../useAppDispatch'
import { TBundle } from '../../interfaces'
import {
  setCurrentBundle,
  setCurrentBundlePrice,
  setCurrentBundlePriceValue,
  setCurrentBundleSubtotal,
} from '../../redux/slices/catalog'
import useAppSelector from '../useAppSelector'
import formatPrice, { stripHiddenPrice } from '../../utils/formatPrice'

export const useBundlesHandler = () => {
  const dispatch = useAppDispatch()
  const selectedProduct = useAppSelector(
    (state) => state.catalogSlice.selectedProduct,
  )
  const config = useAppSelector((state) => state.defaultSlice.config)
  const currentBundleCount = useAppSelector(
    (state) => state.catalogSlice.currentBundleCount || 0,
  )
  const bundlesHandler = ({
    selections,
    completed,
  }: {
    selections: TBundle[]
    completed: boolean
  }) => {
    const validBundlesExtra = selectedProduct?.bundlesExtra || []
    const hasDynamicPrice = !!selectedProduct?.hasDynamicPrice
    if (hasDynamicPrice) {
      const bundleSubtotal = validBundlesExtra.reduce<number>(
        (acc, { sku, price }) => {
          const validSku = sku || ''
          const selectionResult = selections.find(
            (selection) => !!selection[validSku],
          )
          const validSelectionQuantity = selectionResult?.[validSku] || 0
          const validPrice = price || 0
          return validPrice * validSelectionQuantity + acc
        },
        0,
      )

      const currency: string | undefined =
        config?.options?.currency || config?.options?.currencySymbol
      const format: string | undefined = config?.options?.format

      const formattedBundlePrice = formatPrice({
        currency,
        format,
        price: bundleSubtotal,
        hidePrices: config?.options?.hidePricesActive,
      })
      const strippedBundlePrice = stripHiddenPrice(formattedBundlePrice)
      dispatch(
        setCurrentBundlePrice(
          strippedBundlePrice ? ` (${strippedBundlePrice})` : '',
        ),
      )
      dispatch(setCurrentBundlePriceValue(bundleSubtotal * currentBundleCount))
      dispatch(setCurrentBundleSubtotal(bundleSubtotal))
    }

    dispatch(setCurrentBundle({ selections, completed }))
  }
  return bundlesHandler
}

export default useBundlesHandler
